import * as Api from '../../../../global/js/api';
import {ifCond} from '../../../../global/helpers/handlebarsHelpers';
import {saveSelectedStore, checkLocalStorage, storeNameShorter} from '../../../../global/js/findInStore';
import {spinnerService} from '../../../../global/js/spinnerService';
import GoogleMapsApi from '../../../../global/js/googleMapsApi';
import * as utils from '../../../../global/js/utils';
import {handleTimeOutRequest} from '../../../../global/js/cart';

const NS = 'StoreAvailability';
const CLS = 'storeAvailNew';
const WG = '.' + CLS + '-';
const CLS_SELECTED = 'is-selected';
const CLS_LOADING = 'is-loading';
const EVT_SET_REGION = `${CLS}.setRegion`;
const EVT_SET_PRICE = `${CLS}.setPrice`;

export class StoreAvailability {
	constructor(el) {
		this.el = el;
		this.$el = $(el);
		this.$btn = $('.storeAvailability-btn');
		this.$changeStore = $('.storeAvailability-changeStore');
		this.$tbody = $(`.${CLS}-tbody`);
		this.$resultContainer = $(`.${CLS}-store-container`);
		this.$modal = $(`#${CLS}-modal`);
		this.$storeContainer = $(`.${CLS}-body`);
		this.$table = this.$el.find(`.${CLS}-table`);
		this.$checkAvailBtn = $('.pdp-desc-store .storeAvailability-btn');
		this.gmapApi = new GoogleMapsApi('callback_regionStorePopup');
		this.checkAvailabilityApi = this.$el.data('checkAvailabilityApi');
		this.productCode = this.$el.data('productCode');
		this.productType = this.$el.data('productType');
		this.lowStock = this.$el.data('lowStock');
		this.outOfStock = this.$el.data('outOfStock');
		this.storeList = [];
		this.colourSelected = '';
		this.apiGetVariants = `/api/findinstore/variantdetails?productCode=${this.productCode}&storeId=`;
		this.stateSearchStore = false;

		this.storeInfo = {
			storeId: '',
			storeName: '',
			contentLinkID: '',
			regionId: '',
			branchSearch: '',
		};
	}

	init() {
		this.initCustomEvent();
		this.initSearchForm();
		this.setStockTemplate();
		this.handleBtn();
	}

	initCustomEvent() {
		this.el.addEventListener(EVT_SET_REGION, (e) => {
			let localStorage = checkLocalStorage();
			this.storeInfo = localStorage.storeInfo;
		});
	}

	initSearchForm() {
		const This = this;
		const $pg = $(this.$el);
		let googleApiKey = window.googleApiKey;
		let locationInput = $pg.find('#input-search-storeAvailability');
		let localStorage = checkLocalStorage();
		this.storeInfo = localStorage.storeInfo;

		this.gmapApi.load(googleApiKey);

		$('.storeAvailNew-formInput .btn-search').on('click', function() {
			This.geoLocSearchCall();
		});

		locationInput.on('input', function() {
			let $val = $(this).val();
			setTimeout(function() {
				if (locationInput.val() == $val) {
					if ($val.length > 1 && !window.callInProgress) {
						window.callInProgress = true;
						This.geoLocSearchCall();
					}
				}
			}, 500);
		});

		// clicks outside pg and outside the results wrapper will close it and clear its content
		$(document).on('click', function(event) {
			if (!$(event.target).closest('#input-search-storeAvailability, .predictions-results').length) {
				let resultsWrapper = $pg.find('.predictions-results');
				resultsWrapper.find('ul').empty();
				resultsWrapper.removeClass('is-active');
			}
		});

		$pg.on('click', '.predictions-results li:not(.empty-result)', function() {
			let text = $(this).text();
			locationInput.val(text);
			let resultsWrapper = $pg.find('.predictions-results');
			resultsWrapper.find('ul').empty();
			resultsWrapper.removeClass('is-active');
			This.storeInfo.branchSearch = text;
			let endpoint = `${This.checkAvailabilityApi}?productCode=${This.productCode}&branch=${This.storeInfo.branchSearch}`;
			This.stateSearchStore = true;
			This.renderStoreList(endpoint, true, true);
		});

		this.$el.find('.product-options li').on('click', function() {
			$('.product-options li.active').removeClass('active');
			let $color = $(this);
			let $colourName = $('.storeAvailNew .product-variant-heading span');
			This.colourSelected = $color.data('colour-code');
			$colourName.html($color.data('color-name'));
			$color.addClass('active');
			const fullData = This.fullData();
			This.renderStock(fullData);
			This.setPrice();
		});

		$pg.on('change', '#selectBoxStore', function(_, data) {
			let regionId = data.value;
			This.storeInfo.regionId = regionId;
			let getVariants = This.apiGetVariants + This.storeInfo.regionId;
			This.stateSearchStore = true;
			This.renderStoreList(getVariants, true, true);
		});

		$('#storeAvailNew-modal').on('show.bs.modal', function(event) {
			$('html').addClass('modal-open');
			$('.storeAvailNew-tbody').animate({scrollTop: 0}, 300);
		});
		$('#storeAvailNew-modal').on('hide.bs.modal', function(event) {
			locationInput.val('');
			$('html').removeClass('modal-open');
			This.resetData();
		});
	}

	resetData() {
		const localStorage = checkLocalStorage();
		this.storeInfo = localStorage.storeInfo;
		this.stateSearchStore = false;
		this.$resultContainer.css('display', 'none');
		this.storeList = [];
	}

	fullData() {
		return !this.storeInfo || !this.storeInfo.storeId || this.stateSearchStore;
	}

	geoLocSearchCall() {
		let $pg = this.$el;
		window.$storePopup = $pg;
		let searchTerm = $pg.find('#input-search-storeAvailability').val();
		let iconSpinner = $pg.find('.icon-spinner');
		let cntry = 'NZL';
		handleTimeOutRequest(
			(resolve, reject) => {
				try {
					this.gmapApi.getPlacePredictions(searchTerm, {
						offset: searchTerm.length,
						componentRestrictions: {country: cntry},
						types: ['(regions)'],
					}).then((response)=> {
						let predictions = response.predictions;
						let status = response.status;
						resolve({
							predictions,
							status,
						});
					}).catch((e) => {
						resolve(e);
					});
				} catch (error) {
					reject(error);
				}
			},
			this.displayGeoLocResults,
			this.displayChoseStoreFallback.bind(this)
		);
		iconSpinner.addClass('is-active');
	}

	displayChoseStoreFallback() {
		this.$el.find('.storeAvailNew-normal').hide();
		this.$el.find('.storeAvailNew-fallback').show();
	}

	displayGeoLocResults(predictions, status) {
		let resultsWrapper = window.$storePopup.find('.predictions-results');
		resultsWrapper.find('ul').empty();
		resultsWrapper.addClass('is-active');
		// eslint-disable-next-line no-undef
		if (status !== 'OK') {
			// an error occurd or no results
			resultsWrapper.find('ul').append(`<li class="empty-result">No results found. Please try a more generic keyword.</li>`);
		} else {
			predictions.forEach(function(prediction) {
				let predTypes = prediction.types;
				if (
					$.inArray('country', predTypes) == -1 &&
					$.inArray('point_of_interest', predTypes) == -1
				) {
					resultsWrapper.find('ul').append(`<li>${prediction.description}</li>`);
				}
			});
		}
		window.callInProgress = false;
		window.$storePopup.find('.icon-spinner').removeClass('is-active');
	}

	renderStoreList(endpoint, tableLoading, fullData) {
		if (tableLoading) {
			this.$table.addClass(CLS_LOADING);
			spinnerService.appendTo(this.$table, true);
		}
		$(this.$el).find('.error-messages').removeClass('is-active');
		Api.getApi(endpoint).then((data) => {
			if (data.result == 'SUCCESS') {
				let res = data.response.storeList;
				if ((res) && (res.length > 0)) {
					this.storeList = res;
					this.setStockStatus();
					this.reorderStore();
					this.renderStock(fullData);
				} else {
					let errorMsg = 'Please search for a branch and select one from the autocomplete list. If no branch is found, please select a different address';
					$(this.$el).find('.error-messages').addClass('is-active').text(errorMsg);
				}
				this.$modal.modal('show');
			} else {
				let errorMsg = data.message || `Can't check stock availability. Please try again.`;
				let errorTmpl = `
					<div class="alert alert-danger fade show mt-2 fsp-13 p-2" role="alert">
						${errorMsg}
						<button type="button" class="close" data-dismiss="alert" aria-label="Close" style="margin-top: -3px;">
							<span aria-hidden="true">&times;</span>
						</button>
					</div>
				`;

				$(errorTmpl).insertAfter(this.$checkAvailBtn);
			}

			this.$checkAvailBtn.removeClass(CLS_LOADING);
			spinnerService.removeFrom(this.$checkAvailBtn);
			if (tableLoading) {
				this.$table.removeClass(CLS_LOADING);
				spinnerService.removeFrom(this.$table);
			}
		}).catch((error) => {
			this.$table.removeClass(CLS_LOADING);
			spinnerService.removeFrom(this.$table);
		});
	}

	handleBtn() {
		this.$btn.on('click', () => {
			this.checkAvailability(this.$btn);
		});
		this.$changeStore.on('click', () => {
			this.checkAvailability(this.$changeStore);
		});
	}

	checkAvailability($parentEl) {
		let $alert = $parentEl.next('.alert');
		if ($alert) {
			$alert.alert('close');
		}
		let colorList = this.$el.find('.product-options li');
		let PDPSelectedColor = window.PDP.currentVariant.color;
		if (colorList.length) {
			if (PDPSelectedColor) {
				this.$el.find(`.product-options li[data-variant-code=${PDPSelectedColor}]`).trigger('click');
			} else {
				$(colorList[0]).trigger('click');
			}
		} else {
			this.setPrice();
		}
		if (this.storeInfo.branchSearch || this.storeInfo.regionId || this.storeInfo.storeId) {
			if (!$parentEl.hasClass('storeAvailability-changeStore')) {
				this.$checkAvailBtn.addClass(CLS_LOADING);
				spinnerService.appendTo(this.$checkAvailBtn, true);
			}
			let endpoint = '';
			let callStoreDetaiApi = false;
			if (this.storeInfo.branchSearch) {
				let branch = this.storeInfo.branchSearch;
				endpoint = `${this.checkAvailabilityApi}?productCode=${this.productCode}&branch=${branch}`;
			} else if (this.storeInfo.storeId) {
				endpoint = `/api/findinstore/store-variant-detail?productCode=${this.productCode}&fulfilmentNumber=${this.storeInfo.storeId}`;
				callStoreDetaiApi = true;
			} else {
				endpoint = this.apiGetVariants + this.storeInfo.regionId;
			}
			const fullData = this.fullData();
			if (!(callStoreDetaiApi && !this.storeInfo.storeId)) {
				this.renderStoreList(endpoint, false, fullData);
			}
		} else {
			this.$modal.modal('show');
		}
	}

	// set if variant in stock, low stock, or out-of-stock
	setStockStatus() {
		let stockStatus = (stockOnHand, quantity) => {
			let remainingStock = stockOnHand - quantity;
			let status = 'stockInfo--in';
			if (remainingStock <= this.lowStock && remainingStock >= this.outOfStock) {
				status = 'stockInfo--low';
			} else if (remainingStock < this.outOfStock) {
				status = 'stockInfo--out';
			}

			return status;
		};
		const $pdp = $('[data-pg="ProductDetailsUpdate"]');
		let quantity = parseInt($pdp.find('.pdp-desc-qty input').val());
		this.storeList.forEach((store) => {
			// set selected store
			// make sure compare string to string
			if (`${this.storeInfo.storeId}` === `${store.storeId}`) {
				store.selected = true;
			}
			// check product type (generic, color, size, colorSize)
			switch (this.productType) {
				case 'color':
					if (store.colorList && store.colorList.length > 0) {
						store.colorList.forEach((item) => {
							item.stockStatus = stockStatus(item.stockOnHand, quantity);
						});
					}
					break;
				case 'size':
					if (store.sizeList && store.sizeList.length > 0) {
						store.sizeList.forEach((item) => {
							item.stockStatus = stockStatus(item.stockOnHand, quantity);
						});
					}
					break;
				case 'colorsize':
					if (store.colorList && store.colorList.length > 0) {
						store.colorList.forEach((clr) => {
							if (clr.sizes && clr.sizes.length > 0) {
								clr.sizes.forEach((item) => {
									item.stockStatus = stockStatus(item.stockOnHand, quantity);
								});
							}
						});
					}
					break;
				default:
					// generic
					store.stockStatus = stockStatus(store.stockOnHand, quantity);
					store.stockText = 'Stock';
					break;
			}
		});
	}

	// selected store will show on the first list of modal
	reorderStore() {
		this.storeList.sort((x, y) => y.selected - x.selected);
	}

	setStockTemplate() {
		let itemFile = require('../../../widgets/storeAvailability/tmpl/storeAvailabilityStockNew.hbs');
		Handlebars.registerPartial('storeAvailabilityStock', itemFile);
		Handlebars.registerHelper('ifCond', ifCond);

		let itemTmpl = `
			{{> storeAvailabilityStock
				wg="storeAvailNew"
			}}
		`;

		let precompiled = new Function('return ' + Handlebars.precompile(itemTmpl))();
		this.stockTmpl = Handlebars.template(precompiled);
	}

	renderStock(loadFullData) {
		// only show full list store when search, others show 1 store selected
		let model = {
			storeList: !loadFullData && this.storeList.length > 2 ? [this.storeList[0]] : this.storeList,
			selectedColor: this.colourSelected,
			lowStock: this.lowStock,
			outOfStock: this.outOfStock,
		};

		let html = this.stockTmpl(model);
		this.$tbody.html(html);
		if (html.trim() !== '') {
			this.$resultContainer.css('display', 'block');
		}
		this.handleMyStoreBtn();
	}

	handleMyStoreBtn() {
		this.$el.find(`.${CLS}-myStoreBtn`).each((i, btn) => {
			btn.addEventListener('click', (e) => {
				e.preventDefault();
				let $parent = $(btn).closest(`.${CLS}-trow`);
				let isSelected = $parent.hasClass(CLS_SELECTED);
				this.storeInfo.storeId = $parent.data('id');
				this.storeInfo.storeName = storeNameShorter($parent.data('name'));
				this.storeInfo.contentLinkID = $parent.data('content-link-id');

				if (!isSelected) {
					$parent.addClass(CLS_LOADING);
					spinnerService.appendTo($parent, true);
					saveSelectedStore(this.storeInfo, () => {
						this.$el.find(`.${CLS}-trow`).removeClass(CLS_SELECTED);
						$parent.addClass(CLS_SELECTED);
						$parent.removeClass(CLS_LOADING);
						spinnerService.removeFrom($parent);
						// updated selected store on storeList
						this.storeList.map((item) => {
							item.selected = item.storeId === this.storeInfo.storeId;
						});
						this.$modal.modal('hide');

						utils.dispatchEvent('[data-wg="RegionStorePopup"]', 'regionStorePopup.setStore');
						utils.dispatchEvent('[data-pg="ProductDetailsUpdate"]', 'pdp.setStore', {resetNearbyStore: true});
					});
				}
			});
		});
	}

	setPrice() {
		const PDP = window.PDP;
		if (PDP) {
			const $pg= $(this.$el);
			const $pdp = $('[data-pg="ProductDetailsUpdate"]');
			const productType = $pdp.attr('data-item-type');
			let $wrapperPrice = $pg.find('.storeAvailNew-productDetail .price');
			let displayPrice = utils.convertStringToHTML(PDP.displayPrice);
			let defaultPrice = $(displayPrice)[0].firstChild.innerHTML;
			if (defaultPrice.includes('Was')) {
				defaultPrice = `<div class="defaultPrice">${defaultPrice}</div><div class="nowPrice">${$(displayPrice)[0].lastChild.innerHTML}</div>`;
			} else if (defaultPrice.includes('Now')) {
				defaultPrice = `<div class="nowPrice">${defaultPrice}</div>`;
			}
			if (productType !== 'color') {
				if (PDP.displayPrice) {
					$wrapperPrice.html(defaultPrice);
				}
			} else {
				let colorOption = $pg.find('.product-options li.active');
				let variantCode = colorOption.attr('data-variant-code');
				let priceVariant = PDP.price && PDP.price[variantCode];
				let selectedVariant = true;
				if (colorOption.length == 0) {
					selectedVariant = false;
				}

				if (priceVariant && selectedVariant) {
					const {showWasNowFlag, listPrice, salePrice, isDiscountPrice, isClearancePrice, isPromotionPrice} = priceVariant;

					(listPrice.amount) ? listPrice.amount = Number(listPrice.amount).toFixed(2) : null;
					(salePrice.amount) ? salePrice.amount = Number(salePrice.amount).toFixed(2) : null;

					let detailDisplay = '';
					let originPrice = listPrice.amount? `<div class="defaultPrice">Was $${listPrice.amount}</div>` : '';
					let nowPrice = salePrice.amount? `<div class="nowPrice">Now $${salePrice.amount}</div>` : '';
					let normalPrice = salePrice.amount? `<div>$${salePrice.amount}</div>` : '';

					if (isClearancePrice) {
						detailDisplay = nowPrice;
					} else if (isDiscountPrice) {
						detailDisplay = nowPrice;
					} else if (isPromotionPrice) {
						if (showWasNowFlag) {
							detailDisplay = originPrice + nowPrice;
						} else {
							detailDisplay = nowPrice;
						}
					} else {
						detailDisplay = normalPrice;
					}
					$wrapperPrice.html(detailDisplay);
				} else {
					// show display price
					if (PDP.displayPrice) {
						$wrapperPrice.html(defaultPrice);
					}
				}
			}
		}
	}
}



// WEBPACK FOOTER //
// D:/AzureDevops/vsts-agent-win-x64-2.202.1_06/_work/151/s/FrontEnd/src/views/widgets/storeAvailability/js/storeAvailabilityNew.js